import locations from "./locations";
import Papa from "papaparse";
import {maxBy, minBy} from "lodash";
import moment from "moment";
import axios from "axios";

export const fetchAPIData = async(site,key) => {
    return new Promise((resolve, reject) => {
        (async () => {
            const now = new Date();
            const year = now.getFullYear().toString();
            let month = (now.getMonth() + 1).toString();
            let day = now.getDate().toString();
            let hour = now.getHours().toString();

            if (day.length < 2) day = "0" + day;
            if (hour.length < 2) hour = "0" + hour;
            if (month.length < 2) month = "0" + month;

            const url = `https://idu48c11uf.execute-api.us-west-1.amazonaws.com/prod/solar_proxy?site_id=${site}&`;
            const siteOperationDates = await axios.get(url + `type=dataPeriod&api_key=${key}`).catch(e=>{console.log(e)});
            const curr = await axios.get(url + `type=energyDetails&meters=PRODUCTION,CONSUMPTION&timeUnit=HOUR&startTime=${year}-${month}-${day}%20${hour}:00:01&endTime=${year}-${month}-${day}%20${hour}:59:59&api_key=${key}`).catch(e=>{console.log(e)});
            const currDay = await axios.get(url + `type=energyDetails&meters=PRODUCTION,CONSUMPTION&timeUnit=DAY&startTime=${year}-${month}-${day}%2000:00:01&endTime=${year}-${month}-${day}%2023:59:59&api_key=${key}`).catch(e=>{console.log(e)});
            const currMonth = await axios.get(url + `type=energyDetails&meters=PRODUCTION,CONSUMPTION&timeUnit=MONTH&startTime=${year}-${month}-01%2000:00:01&endTime=${year}-${month}-${day}%2023:59:59&api_key=${key}`).catch(e=>{console.log(e)});
            const currYear = await axios.get(url + `type=energyDetails&meters=PRODUCTION,CONSUMPTION&timeUnit=YEAR&startTime=${year}-01-01%2000:00:01&endTime=${year}-12-31%2023:59:59&api_key=${key}`).catch(e=>{console.log(e)});
            const ever = await axios.get(url + `type=energyDetails&meters=PRODUCTION,CONSUMPTION&timeUnit=YEAR&startTime=${siteOperationDates.data.dataPeriod.startDate}%2000:00:01&endTime=${year}-${month}-${day}%2023:59:59&api_key=${key}`).catch(e=>{console.log(e)});

            /*if(site==='3216399') {
                console.log('curr', url + `type=energyDetails&meters=PRODUCTION,CONSUMPTION&timeUnit=HOUR&startTime=${year}-${month}-${day}%20${hour}:00:01&endTime=${year}-${month}-${day}%20${hour}:59:59&api_key=${key}`)
                console.log('currDay', url + `type=energyDetails&meters=PRODUCTION,CONSUMPTION&timeUnit=DAY&startTime=${year}-${month}-${day}%2000:00:01&endTime=${year}-${month}-${day}%2023:59:59&api_key=${key}`)
                console.log('currMonth', url + `type=energyDetails&meters=PRODUCTION,CONSUMPTION&timeUnit=MONTH&startTime=${year}-${month}-01%2000:00:01&endTime=${year}-${month}-${day}%2023:59:59&api_key=${key}`)
                console.log('currYear',url + `type=energyDetails&meters=PRODUCTION,CONSUMPTION&timeUnit=YEAR&startTime=${year}-01-01%2000:00:01&endTime=${year}-12-31%2023:59:59&api_key=${key}`)
                console.log('ever', url + `type=energyDetails&meters=PRODUCTION,CONSUMPTION&timeUnit=YEAR&startTime=${siteOperationDates.data.dataPeriod.startDate}%2000:00:01&endTime=${year}-${month}-${day}%2023:59:59&api_key=${key}`)
            }*/

            resolve([curr, currDay, currMonth, currYear, ever])
        })()
    });
}

export const loadLocations = () => {
    for(let i=0;i<locations.length;i++) {
        if(locations[i].sonnen_file !== '') {
            Papa.parse(locations[i].sonnen_file, {
                download: true,
                error: function(e) {
                    console.log(e)
                },
                complete: function (input) {
                    const data = input.data.slice(3);
                    const min = minBy(data, function (o) {
                        return o[0];
                    });
                    const max = maxBy(data, function (o) {
                        return o[0];
                    });
                    const min_date = moment.unix(min[0]).format('L');
                    const max_date = moment.unix(max[0]).format('L');
                    locations[i].data = {
                        min_date,
                        max_date,
                        data
                    };
                }
            });
        } else {
            locations[i].data = null;
        }
    }
    return locations;
}